import {makeGetCongenereEligibility} from 'main/factories/usecases/private/remote-home/get-congenere-eligibility-factory';

export const getCongenereEligibility = (signal?: AbortSignal) =>
	makeGetCongenereEligibility().get(signal);
